export default __webpack_public_path__ + "static/media/paymentmob.00eb4e20.png";